import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import Select from 'react-select';
import * as Actions from 'actions';
import { getMarkerTypes, fetchMarkers } from 'api';
import { UserSelect } from 'components';

import {
  MarkerOptions,
  MarkerOptionsSettings
} from 'components';

class MarkerOptionsContainer extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      marker_types : null,
    }

    this.handleSelectUser = this.handleSelectUser.bind(this);
    this.handleClickSettings = this.handleClickSettings.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.optionRenderer = this.optionRenderer.bind(this);
  }
  handleSelectUser(option) {
    this.props.updateMarkerFilterUser(option && option.value || null);
  }
  handleClickSettings(e) {
    e.preventDefault();
    this.props.toggleShowMarkerSettings();
  }
  handleFilterChange(markers) {
    this.props.updateMarkerFilters(markers.map(m => m.marker.key));
  }
  optionRenderer(marker_type) {
    const { name, url } = marker_type.marker;
    const { baseUrl, imagesPath } = this.props.connection;
    return (
      <Row>
        <Col md={2} xs={2}>
          <img src={`${baseUrl}${imagesPath}${url}`} className='marker-filter-selector-image'/>
        </Col>
        <Col md={10} xs={10}>
          <p>{name}</p>
        </Col>
      </Row>
    )
  }
  componentDidMount() {
    getMarkerTypes()
    .then(marker_types => this.setState({ marker_types }))
    .catch(e => console.log('Error getting marker types : ', e.message || e));
  }

  render() {
    const can_manage = this.props.hasPermission('/Canvassing/Markers/Manage/');
    const { marker_types, filtered_marker_types, filter_user } = this.props.canvassing;
    return (
      <div className='marker-options-container'>
        <Row className='mb-md'>
          <Col md={12}><h4>MARKER FILTERS</h4></Col>
          <Col md={12} xs={12}>
            <Select
              options={marker_types.map(t => ({ value: t.key, label: t.name, marker: t }))}
              optionRenderer={this.optionRenderer}
              multi={true}
              value={filtered_marker_types}
              onChange={this.handleFilterChange}
              closeOnSelect={false}
            />
          </Col>
          <Col className='mt-sm' xs={12} md={12}>
            <UserSelect
              placeholder={'Select User to Filter'}
              value={filter_user || ''}
              onChange={this.handleSelectUser}
            />
          </Col>
        </Row>
        <Row>
          <Col md={10} xs={10}>
            {this.props.canvassing.show_marker_settings ? <h4>MARKER SETTINGS</h4> : <h4>CURRENT MARKERS</h4>}
          </Col>
          {can_manage ? (
            <div className='col-md-2 col-xs-2 marker-options-cog-container'>
              <div
                className='pull-right marker-options-settings-toggle'
                onClick={this.handleClickSettings}
                >
                <i className={`fa ${this.props.canvassing.show_marker_settings ? 'fa-close' : 'fa-cog'} `} />
              </div>
            </div>
          ) : null}
        </Row>
        {can_manage && this.props.canvassing.show_marker_settings ?
        <MarkerOptionsSettings key='marker-options-settings' marker_types={this.state.marker_types} /> :
        <MarkerOptions key='marker-options' place={this.props.place} current_location={this.props.current_location} />}
      </div>
    )
  }
}

const mapStateToProps = ({ canvassing, connection }) => ({ canvassing, connection });

export default connect(mapStateToProps, Actions)(MarkerOptionsContainer)



// WEBPACK FOOTER //
// ./src/browser/components/clients/canvassing/marker-options-container.js